module.exports = __webpack_public_path__ + "img/icon-skins-shadow.e149c07d.png";